const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy_mono/apps/pinktool/src/routes/_app/ranks.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { TbX } from "react-icons/tb";
import type { UpdateRankInputBody } from "@/api/types.gen";
export const Route = createFileRoute("/_app/ranks")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface RankModalProps {
  isOpen: boolean;
  onClose: () => void;
  rank: Rank;
  onSuccess: () => void;
}